import { faEdit, faEllipsisV, faHandHoldingDollar, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import cn from 'classnames';
import { deleteCashbox } from '@redux/features/cashboxesSlice';
import { getEntityLink } from 'helpers/getEntityLink';
import { ConfirmDeletionModal } from 'components/ConfirmDeletionModal';
import { Button } from 'components/Button';
import styles from './Actions.scss';

export const Actions = ({ className, cashbox, setEditingCashbox, setPaymentMethodsCashbox }) => {
  const [isShowActions, setIsShowActions] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleShowPaymentMethods = (e) => {
    e.stopPropagation();
    setPaymentMethodsCashbox(cashbox);
  };

  const handleEditCashbox = (e) => {
    e.stopPropagation();
    setEditingCashbox(cashbox);
  };

  const handleDelete = async (e) => {
    e.stopPropagation();
    const resultAction = await dispatch(deleteCashbox(cashbox.id));

    if (deleteCashbox.fulfilled.match(resultAction)) {
      navigate(getEntityLink('finance'));
    }
  };

  return (
    <div className={styles.actions} onMouseLeave={() => setIsShowActions(false)}>
      <Button
        className={cn(styles.button, className, { [styles.active]: isShowActions })}
        onClick={(e) => {
          e.stopPropagation();
          setIsShowActions(true);
        }}
        noStyle
      >
        <FontAwesomeIcon icon={faEllipsisV} />
      </Button>
      <div className={cn(styles.modal, { [styles.open]: isShowActions })}>
        <Button className={styles.actionBtn} onClick={handleShowPaymentMethods} noStyle>
          <FontAwesomeIcon className={styles.icon} icon={faHandHoldingDollar} />
          Способи поповнення
        </Button>
        <Button className={styles.actionBtn} onClick={handleEditCashbox} noStyle>
          <FontAwesomeIcon className={styles.icon} icon={faEdit} />
          Редагувати
        </Button>
        <Button
          className={cn(styles.actionBtn, styles.deleteBtn)}
          onClick={(e) => {
            e.stopPropagation();
            setIsConfirmOpen(true);
          }}
          noStyle
        >
          <FontAwesomeIcon className={styles.icon} icon={faTrash} />
          Видалити
        </Button>
      </div>
      <ConfirmDeletionModal
        isOpen={isConfirmOpen}
        setIsOpen={setIsConfirmOpen}
        elementName='рахунок'
        onConfirm={handleDelete}
      />
    </div>
  );
};
